import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

async function searchUsersAlgolia(
  searchQuery: string,
  pageToFetch: number,
  hitsPerPage: number,
  auth: Authentication
): Promise<{ hits: Record<string, any>[]; nbHits: number; page: number }> {
  try {
    const params = new URLSearchParams({
      q: searchQuery,
      page: String(pageToFetch),
      hitsPerPage: String(hitsPerPage),
    });
    const json = await HttpClient.get(
      `/algolia/search/backoffice/users?${params.toString()}`,
      auth.token
    );
    
    return {
      hits: json.hits,
      nbHits: json.nbHits,
      page: pageToFetch,
    };
  } catch (e) {
    console.error('[Algolia] erreur :', e);
    throw new SearchUsersAlgoliaFailure();
  }
}

export class SearchUsersAlgoliaFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default searchUsersAlgolia;
